if (!customElements.get('product-description-collapse')) {
  customElements.define(
    'product-description-collapse',
    class ProductDescriptionCollapse extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-description-body]');
        this.toggle = this.querySelector('[data-description-toggle]');
        this.labelMore = this.querySelector('[data-label-more]');
        this.labelLess = this.querySelector('[data-label-less]');

        this.#stripCustomizeSection();
        if (!this.body || !this.toggle) return;

        this.toggle.addEventListener('click', () => this.#toggle());
        this.#sync();
        if (typeof ResizeObserver !== 'undefined') {
          this.ro = new ResizeObserver(() => this.#sync());
          this.ro.observe(this.body);
        }
      }

      disconnectedCallback() {
        this.ro?.disconnect();
      }

      #toggle() {
        this.classList.toggle('is-expanded');
        this.#updateLabels();
      }

      #updateLabels() {
        const expanded = this.classList.contains('is-expanded');
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (this.labelMore) this.labelMore.toggleAttribute('hidden', expanded);
        if (this.labelLess) this.labelLess.toggleAttribute('hidden', !expanded);
      }

      #normalizeText(value) {
        return String(value || '')
          .replace(/\u00a0/g, ' ')
          .replace(/[\u200B-\u200D\uFEFF]/g, '')
          .replace(/\s+/g, ' ')
          .replace(/[\u201C\u201D\u201E\u2033]/g, '"')
          .replace(/[\u2018\u2019\u201B\u2032]/g, "'")
          .trim();
      }

      #isCustomizeNotice(text) {
        const t = this.#normalizeText(text);
        return (
          t.includes('Customize: Select') &&
          t.includes('Yes | See Description') &&
          t.includes('printing fee') &&
          t.includes('No further payment is required')
        );
      }

      // 删掉指定 Customize 说明整段（p / strong 包一层都能命中）
      #stripCustomizeSection() {
        const root = this.querySelector('.product__description');
        if (!root) return;

        for (const p of [...root.querySelectorAll('p')]) {
          if (this.#isCustomizeNotice(p.textContent)) {
            p.remove();
            return;
          }
        }

        for (const strong of [...root.querySelectorAll('strong')]) {
          if (!this.#isCustomizeNotice(strong.textContent)) continue;
          const block = strong.closest('p') || strong;
          block.remove();
          return;
        }

        if (this.#isCustomizeNotice(root.textContent)) {
          root.replaceChildren();
        }
      }

      #sync() {
        if (this.classList.contains('is-expanded')) {
          this.toggle.hidden = false;
          this.#updateLabels();
          return;
        }
        const overflows = this.body.scrollHeight > this.body.clientHeight + 4;
        this.toggle.hidden = !overflows;
        this.classList.toggle('is-collapsible', overflows);
        this.#updateLabels();
      }
    }
  );
}
